module.exports = __webpack_public_path__ + "icomoon.svg?567711efd5fe18420ff3cd0f603e798b";